var _g, _g2, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreencheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9546 0C22.3654 0 0 22.3654 0 49.9546C0 77.5438 22.3654 99.9092 49.9546 99.9092C77.5438 99.9092 99.9092 77.5438 99.9092 49.9546C99.9092 22.3654 77.5438 0 49.9546 0Z",
    fill: "#73D260"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.200712
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9551 3.375C24.441 3.375 3.75781 24.0582 3.75781 49.5723C3.75781 75.0864 24.441 95.7696 49.9551 95.7696C75.4692 95.7696 96.1524 75.0864 96.1524 49.5723C96.1524 24.0582 75.4692 3.375 49.9551 3.375Z",
    fill: "#6DDB57"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1281,
    cy: 49.675,
    r: 35.675,
    fill: "#3FB827"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1193 55.2845L62.44 39.9639L64.797 42.3209L47.1193 59.9985L36.5127 49.392L38.8697 47.035L47.1193 55.2845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheck);
export default __webpack_public_path__ + "static/media/greencheck.756eb6be88e371f2fe2e29dc433a8802.svg";
export { ForwardRef as ReactComponent };